// The file structure: id: "text"
// for additional description there will be // over the id: "text"
// Strings with ${variable} in are generated, ${} meand variable require for proper message display
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import colors from "constants/colors";
import Pill from "newComponents/Shared/_Atoms/Pill/Pill";
import React from "react";

const INFOS = {
  // CLASSROOMS SAGA
  handleAssignLessonToClass:
    "Assigning all lessons may take a moment. All lessons should be visible after returning to this page.",
  handleAssignClassroomAssignmentToStudentsSaga: "This process may take some time.",
  assignClassroomAssignmentToStudent: (type: string) =>
    `All classroom's students already assigned to this ${type}`,
  handleAssignWorksheetToClass:
    "Assigning all worksheets may take a moment. All worksheets should be visible after returning to this page.",
  handleUnassignWorksheetToClass: "Unassigning all worksheets may take a moment. ",
  handleUnassignLessonsToClass: "Unassigning all lessons may take a moment.",
  handleAssignCourseTemplateToClass:
    "Assigning all assignments from course template may take a moment. All assignments should be visible after returning to this page.",
  // COURSE TEMPLATES SAGA
  handleApplyTemplateToClass: "It may take a moment to apply all templates to class.",
  // STUDENTS SAGA
  handleAssignLesson:
    "Assigning all lessons may take a moment. All lessons should be visible after returning to this page.",
  handleUnAssignLesson: "Unassigning all lessons may take a moment.",
  baselineTestScoreToolTipAccountTab:
    "<span style='font-weight: 700'>Baseline Test Score</span> (BTS) is an <u>optional</u> field that allows an instructor to manually enter a score for a test that a student took <i>before they began using myPREPcourse</i>. Because students' answer sheets and test booklets are generally unavailable for analysis, it’s not possible to generate a detailed score report. Once you enter a BTS, it replaces the <i>initial</i> test score in all calculations of the student’s score improvement." +
    "<br/>" +
    "<br/>" +
    "<i>Note: entering a BTS does <u>not</u> remove any other test scores; it merely allows instructors to include an earlier test to ensure that the score improvement data is calculated correctly.</i>",
  archiveStudent:
    "Select this option when you no longer want this student to appear on your list of current students. All student data is retained by default.",
  unarchiveStudent:
    "If you confirm, this student will appear on your list of current students. All student data is retained by default.",
  classroomDateStatus: (
    <div className="table-header-tooltip-list-text">
      <div>
        <span style={{ color: colors.black }}>Assigned</span> - Assigned, available
      </div>
      <div>
        <span style={{ color: colors.grey }}>Available</span> - Assigned, not available yet.
      </div>
    </div>
  ),
  generalInactiveTooltip: (type: string) => `This ${type} is inactive or archived.`,
  statusesTooltip: (isClassroom: boolean = false) => (
    <div className="table-header-tooltip-list-text">
      <div>
        <span style={{ color: colors.instructorGreen }}>Completed</span> - Completed
      </div>
      {!isClassroom && (
        <div>
          <span style={{ color: colors.orange }}>Started</span> - Started
        </div>
      )}
      <div>
        <span style={{ color: colors.black }}>Assigned</span> - Assigned, available
      </div>
      <div>
        <span style={{ color: colors.grey }}>Assigned</span> - Assigned, not available yet.
      </div>
      {!isClassroom && (
        <>
          <div>
            <span style={{ color: colors.orange }}>Due: [Date]</span> - Due Today
          </div>
          <div>
            <span style={{ color: colors.red }}>Due: [Date]</span> - Overdue
          </div>
          <div>
            <span style={{ color: colors.red, fontWeight: 700 }}>Due: [Date]</span> - Overdue and
            not Completed
          </div>
          <div>
            <span style={{ color: colors.grey }}>[Date]</span> - Availability date.
          </div>
        </>
      )}
    </div>
  ),
  reviewStatusTooltip: (withVideo: boolean = false) => (
    <div className="table-header-tooltip-list">
      <div>
        <Icon icon="flag" style={{ color: colors.red, height: 16 }} /> - Problems flagged to review
      </div>
      <div>
        <Icon icon="flag" style={{ color: colors.grey, height: 16 }} /> - Problems reviewed
      </div>
      {withVideo && (
        <div>
          <Icon icon="play-circle" style={{ color: colors.grey, height: 20 }} /> - Video watched
        </div>
      )}
    </div>
  ),
  testSectionsScoresTooltip: (isClassroom: boolean = false) => (
    <div className="table-header-tooltip-list">
      <div>
        <Icon icon="math" style={{ color: colors.midGrey, height: 20 }} /> - Section Not Assigned
      </div>
      <div>
        <Icon icon="math" style={{ color: colors.black, height: 20 }} /> - Section Assigned
      </div>
      {!isClassroom && (
        <div>
          <div style={{ position: "relative" }}>
            <Icon icon="math" style={{ color: colors.orange, height: 20 }} />
            <div className="green-dot-marker" style={{ right: -4, top: -2 }} />
          </div>
          - Section Started
        </div>
      )}
      <div>
        <Icon icon="math" style={{ color: colors.instructorGreen, height: 20 }} /> - Section
        Completed
      </div>
    </div>
  ),
  studentReviewRequestsColumnTooltip: (
    <div className="table-header-tooltip-list">
      <div>
        <span style={{ color: colors.red }}>[18]</span> - All assignments flagged to review.
      </div>
      <div>
        <span style={{ color: colors.grey }}>[18]</span> - All assignments already reviewed.
      </div>
    </div>
  ),
  studentTestsColumnTooltip: (
    <div className="table-header-tooltip-list">
      <div className="left-row" style={{ justifyContent: "flex-start" }}>
        <Pill value="Cpl." className="border-pill green" style={{ margin: 3 }} /> - Number of
        Practice tests completed.
      </div>
      <div className="left-row">
        <Pill value="All" className="border-pill grey" style={{ margin: 3 }} /> - Number of All
        Practice Tests assigned.
      </div>
    </div>
  ),
  reviewTestStatusTooltip: "",
  studentListScoreTooltips: (
    <div className="table-header-tooltip-list-text">
      <div>
        <span>Best</span> - Best score
      </div>
      <div>
        <span>Target</span> - Target Score (if available) or Total Score for Course.
      </div>
      <div>
        <span style={{ color: colors.instructorGreen }}> Best / Target</span> - Current Score is
        equal to student's Target Score (if available) or Total Score for Course.
      </div>
    </div>
  ),
  performanceTooltips: (
    <div>
      <div>
        <span style={{ fontWeight: "bold" }}>The Filled-In Area</span> shows the proportion of the
        class that has submitted the assignment.
      </div>
      <div>
        <span style={{ fontWeight: "bold" }}>The %</span> is a measure of class performance that
        indicates the percentage of submitted answers scored as correct.
      </div>
      <div>
        <span style={{ fontWeight: "bold" }}>The Color Scheme</span> provides an at-a-glance measure
        of performance in which green, yellow, orange, and red indicate ranges of proficiency from
        highest to lowest.
      </div>
    </div>
  ),
  startedTestModalInfo: (
    status: string
  ) => `At this point, <b><i>you can no longer remove assigned test sections;</i></b> 
${status === "STARTED" ? "however, you can add previously unassigned test sections." : ""}`,
  emptySubjectsRealTestMessage: (courseName: CourseName) =>
    `Please enter each section score that the student reports earning on the officially administered ${courseName} test. At least one section score must be entered before the test can be saved.`,
  inactiveStudentTooltip:
    "This student account is inactive. Accounts that have not yet been activated are limited to one free practice test. After that, you must activate the account by entering a student license code before you’ll be able to assign lessons, worksheets, or additional tests. Your manager should be able to provide you with activation codes as necessary. However, if you need quick answers, please utilize the chat support feature in the bottom corner of your screen.",
  studentAssignmentsColumnTooltip: (
    <div className="table-header-tooltip-list">
      <div className="left-row" style={{ justifyContent: "flex-start" }}>
        <Pill value="O" className="red-pill" style={{ margin: 3 }} /> - Overdue
      </div>
      <div className="left-row">
        <Pill value="DT" className="orange-pill" style={{ margin: 3 }} /> - Due Today
      </div>
      <div className="left-row">
        <Pill value="DS" className="yellow-pill" style={{ margin: 3 }} /> - Due Soon
      </div>
      <div className="left-row">
        <Pill value="C" className="green-pill" style={{ margin: 3 }} /> - Completed
      </div>
    </div>
  ),
  validEmail:
    "A valid student email address is required for most student functions. You may create an account without an email address, but until a valid email address is entered, the student will not receive the requisite welcome email and cannot login to the system.",
  welcomeEmail:
    "Click the button below to send a welcome email containing a password reset button and instructions for how to log into the system. Caution:To avoid triggering multiple welcome emails, please click the button only once. If the recipient cannot find the email, please be sure to check the recipient's spam folder and wait a few minutes before triggering a second email. If the user still cannot locate the welcome email after a few minutes, then go ahead and send a second one. Each time you resend a welcome email, the password reset button the previous welcome email is disabled.",
  passwordReset:
        "Click the button below to email the user a link to reset their password. NOTE: Sending more than one email in succession can confuse your user. Please allow a few minutes for the email to arrive and have the user check their spam folder before sending a second password reset email.",
  workbookEmail:
    "Click the button below to email the user a link to workbook. NOTE: Sending more than one email in succession can confuse your user. Please allow a few minutes for the email to arrive and have the user check their spam folder before sending a second email.",
  studentsNoEmail: "No emails provided for selected student(s).",

  locationInfo:
    "Depending on your settings, you may have more than one location/branch. The student’s location aﬀects which managers have access to this student.",
  locationManage:
    "If this user manages one or more locations/branches, add them below. This user will be able to view and edit the accounts for all instructors and students at selected locations.",
  generatingReportInfo: "Your score report is being generated. It should be available shortly.",
  instructorsCardInfo:
    "Add one or more instructors to the list below. Each instructor can manage the student’s course.",
  classesInfo:
    "If this student is in a class, add it here. When a student is a member of a class, he or she will automatically be assigned all the classwork.",
  preventLoginInfo:
    "Check this box to temporarily prevent this student from logging in.",
  inactiveInfo: "Set student as inactive for this course.",
  archiveStudentInfo:
    "Select this option when you no longer want this student to appear on your list of current students. All student data is retained and, by default, included in instructor and global statistics.",
  excludeFromStatisticsInfo:
    "Use this option to exclude this student’s data from all instructor and global statistics.",
  deleteAccountInfo:
    "This option will only be available until the student account is activated. Once activated, if you need to delete a student's account, please contact your system administrator.",
  activateCourseInfo: "Ready to begin your course?",
  inactiveStudentTestAssignmentInfo:
    "This student is not activated. A free student account can only be assigned one free test per course.",
  customTableDataLoadingInfo:
    "Your data is loading. This may take a moment for heavier data processing...",
  archiveInstructor:
    "Select this option when you no longer want this instructor to appear on your list of current instructors. All instructor data is retained by default.",
  unarchiveInstructor: "Instructor will show up in your list of current instructors.",
  essayScoringDescription: [
    {
      title: <h2>Score: 8 - Advanced</h2>,
      description: (
        <div>
          <p>The response demonstrates thorough comprehension of the source text.</p>
          <p>
            The response shows an understanding of the text&#39;s central idea(s) and of most
            important details and how they interrelate, demonstrating a comprehensive understanding
            of the text.
          </p>
          <p>The response is free of errors of fact or interpretation with regard to the text.</p>
          <p>
            The response makes skillful use of textual evidence (quotations, paraphrases, or both),
            demonstrating a complete understanding of the source text.
          </p>
        </div>
      )
    },
    {
      title: <h2>Score: 6 - Proﬁcient</h2>,
      description: (
        <div>
          <p>The response demonstrates thorough comprehension of the source text.</p>
          <p>
            The response shows an understanding of the text&#39;s central idea(s) and of most
            important details and how they interrelate, demonstrating a comprehensive understanding
            of the text.
          </p>
          <p>The response is free of errors of fact or interpretation with regard to the text.</p>
          <p>
            The response makes skillful use of textual evidence (quotations, paraphrases, or both),
            demonstrating a complete understanding of the source text.
          </p>
        </div>
      )
    },
    {
      title: <h2>Score: 4 - Partial</h2>,
      description: (
        <div>
          <p>The response demonstrates thorough comprehension of the source text.</p>
          <p>
            The response shows an understanding of the text&#39;s central idea(s) and of most
            important details and how they interrelate, demonstrating a comprehensive understanding
            of the text.
          </p>
          <p>The response is free of errors of fact or interpretation with regard to the text.</p>
          <p>
            The response makes skillful use of textual evidence (quotations, paraphrases, or both),
            demonstrating a complete understanding of the source text.
          </p>
        </div>
      )
    },
    {
      title: <h2>Score: 2 - Inadequate</h2>,
      description: (
        <div>
          <p>The response demonstrates thorough comprehension of the source text.</p>
          <p>
            The response shows an understanding of the text&#39;s central idea(s) and of most
            important details and how they interrelate, demonstrating a comprehensive understanding
            of the text.
          </p>
          <p>The response is free of errors of fact or interpretation with regard to the text.</p>
          <p>
            The response makes skillful use of textual evidence (quotations, paraphrases, or both),
            demonstrating a complete understanding of the source text.
          </p>
        </div>
      )
    }
  ],
  archiveClassroomInfo:
    "Select this option when you no longer want this class to appear on your list of current classes. All class data is retained and, by default, included in instructor and global statistics.",
  deleteClassroomInfo: `This option is only available once you've removed all students from the class. You may hide this class without deleting it by selecting the "inactive" option above.`,
  fetchingStudentTestDetails: "Please wait while fetching test's data."
};

export default INFOS;
